import React, { useCallback } from 'react';
import TextSelector from 'components/Common/TextSelector';
import getAppSite from 'utils/getAppSite';
import time from 'utils/time';
import adjustPDFScale from 'components/Dashboard/utilities/adjustPDFScale';
import useCreateMarkup from 'components/Dashboard/hooks/useCreateMarkup';

const LegislationOverviewContent = ({ currentNew, scrollbarRef, scrolling, reportWidget }) => {
  const { createMarkup } = useCreateMarkup();

  const LegislationContainer = useCallback((node) => {
    if (node !== null) {
      adjustPDFScale(node);
    }
  }, []);

  return (
    <TextSelector currentNew={currentNew} scrollbarRef={scrollbarRef} scrolling={scrolling} reportWidget={reportWidget}>
      <div
        className={`py-3 pr-3 news-content-in legislation-content-in context update-legislation ${
          getAppSite() === 'usa' ? 'legislation-us-content' : ''
        }`}
      >
        {currentNew?.extract ? (
          <>
            <p dangerouslySetInnerHTML={createMarkup(currentNew.extract)}></p>
          </>
        ) : (
          <>
            {currentNew.lastEvents && (
              <div className='row mx-0'>
                <div className='pl-0'>
                  {!!currentNew.session && (
                    <>
                      <h3>Session</h3>
                      <p>{currentNew.session}</p>
                    </>
                  )}

                  <h3>Type of Bill</h3>
                  <p>{currentNew.typeOfBill ? currentNew.typeOfBill : 'No content'}</p>

                  <h3>Summary</h3>
                  <p dangerouslySetInnerHTML={createMarkup(currentNew.summary)}></p>

                  <h3>Sponsor</h3>
                  <p>{currentNew.sponsor ? currentNew.sponsor : 'No content'}</p>
                  {currentNew.nextEventName && (
                    <>
                      <h3>Current stage</h3>
                      <p>{currentNew.nextEventName ? currentNew.nextEventName : 'No content'}</p>
                    </>
                  )}
                  <h3>Previous events</h3>
                  <ul className='policy-list px-0 primary-legislation-list mb-3'>
                    {currentNew.lastEvents
                      .sort((a, b) => a.order - b.order)
                      .map((item, index) => (
                        <li className='py-2' key={`item${index}`}>
                          {item.name}
                        </li>
                      ))}
                  </ul>

                  <a
                    className='legislation-source'
                    href={currentNew.allBillDocumentsUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    View all documents, including amendments, tracked changes to the Bill, briefing papers, etc.
                  </a>
                </div>
              </div>
            )}
            {currentNew.lastEvent && (
              <div className='row mx-0'>
                <div className='pl-0'>
                  {!!currentNew.session && (
                    <>
                      <h3>Session</h3>
                      <p>{currentNew.session}</p>
                    </>
                  )}

                  {!!currentNew.description && (
                    <>
                      <h3>Description</h3>
                      <p>{currentNew.description}</p>
                    </>
                  )}
                  {!!currentNew.sponsors?.length > 0 && (
                    <>
                      <h3>Sponsors</h3>
                      <p>{currentNew.sponsors.join(', ')}</p>
                    </>
                  )}
                  {!!currentNew.lastEvent && currentNew.lastEventDate && (
                    <>
                      <h3>Current stage</h3>
                      <p>
                        {currentNew.lastEvent} (
                        {time(currentNew.lastEventDate, {
                          utc: true,
                          skipTimezone: true,
                        }).formatSimpleGeneralDate()}
                        )
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}
            {currentNew.explanatoryNote ? (
              <>
                <h3>{getAppSite() === 'usa' ? 'Text' : 'Explanatory note'}</h3>
                <div
                  className='explanatory-container'
                  dangerouslySetInnerHTML={createMarkup(currentNew.explanatoryNote)}
                  ref={LegislationContainer}
                ></div>
              </>
            ) : (
              <>
                {getAppSite() === 'usa' && (
                  <>
                    {currentNew.body ? (
                      <>
                        <h3>Text</h3>
                        <div
                          className='explanatory-container'
                          dangerouslySetInnerHTML={createMarkup(currentNew.body)}
                          ref={LegislationContainer}
                        ></div>
                      </>
                    ) : (
                      <div className='explanatory-container'>Download source document for bill text</div>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </TextSelector>
  );
};

export default LegislationOverviewContent;
